var paragraph_default = {
  "fontElementMap": "sWdHw",
  "elementSpacing": "-uA7G",
  "text": "A6brr -uA7G",
  "child": "gaWoH"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
